export type NavChild = {
  label: string
  to: string
  description: string
}

export type NavItem = {
  label: string
  to: string
  children?: NavChild[]
}

export const NAV: NavItem[] = [
  { label: 'Inicio', to: '/' },
  {
    label: 'Soluciones',
    to: '/soluciones',
    children: [
      {
        label: 'Logística & Supply Chain',
        to: '/soluciones/logistica-supply-chain',
        description: 'Consultoría, diseño de red, licitaciones, warehousing y excelencia operacional.',
      },
      {
        label: 'Transporte & Distribución',
        to: '/soluciones/transporte-distribucion',
        description: 'Flota propia, red 3PL y gestión integral de transportistas en todo el país.',
      },
      {
        label: 'Control Tower',
        to: '/soluciones/control-tower',
        description: 'Seguimiento, coordinación, KPIs y medición de SLA en una vista única.',
      },
      {
        label: 'Facility Management',
        to: '/soluciones/facility-management',
        description: 'Limpieza, mantenimiento técnico, control de plagas, parquización y poda.',
      },
      {
        label: 'HSE & Seguridad',
        to: '/soluciones/hse',
        description: 'Auditorías, matriz legal, capacitaciones, EPP y gestión de incidentes.',
      },
      {
        label: 'Tecnología & Control Documental',
        to: '/tecnologia',
        description: 'Plataforma documental, monitoreo satelital, BI y dashboards operativos.',
      },
      {
        label: 'Sustentabilidad',
        to: '/soluciones/sustentabilidad',
        description: 'Medición de huella de carbono, reportes de CO₂ y planes de reducción.',
      },
    ],
  },
  { label: 'Industrias', to: '/industrias' },
  { label: 'Tecnología', to: '/tecnologia' },
  { label: 'Clientes', to: '/clientes' },
  { label: 'Nosotros', to: '/nosotros' },
  { label: 'Contacto', to: '/contacto' },
]

/**
 * Datos de contacto tomados de la documentación corporativa reciente.
 * NO coinciden con la web anterior: revisar antes de publicar.
 */
export const CONTACT = {
  company: 'Rabemar Servicios Integrales',
  address: 'Solís 1518, Pergamino, Provincia de Buenos Aires, Argentina',
  city: 'Pergamino',
  region: 'Buenos Aires',
  country: 'AR',
  commercialContact: 'Claudio Betine Leiva',
  phone: '2475-434452',
  phoneHref: 'tel:+542475434452',
  whatsappHref: 'https://wa.me/542475434452',
  email: 'melena.Leiva@rabemar.com',
  needsValidation: true,
  validationNote: 'VALIDAR ANTES DE GO-LIVE — dato tomado de documentación corporativa reciente, no coincide con la web anterior.',
}

export const PILLARS = [
  'Logística',
  'Facility Management',
  'HSE',
  'Control Tower',
  'Tecnología',
  'Sustentabilidad',
]

export const VERBS = ['Operar', 'Controlar', 'Optimizar', 'Escalar']

export const SITE_URL = 'https://www.rabemar.com'
